import {
  getGeocodingDataFromInput,
  setMarketsMapStateWithAddress,
  getMarketsByTerm
} from '../'
import { parseCookies } from '../'

export const handleSearchByGeocoding = async ({ input, token, mapState }) => {
  const cookies = parseCookies()

  if (cookies['preferencesConsent']) {
    const address = await getGeocodingDataFromInput({ input, token })
    if (!address) return { noResults: true, markets: [] }
    if (address.suggestedAddresses)
      return {
        suggestedAddresses: address.suggestedAddresses,
        noResults: false
      }
    const results = await setMarketsMapStateWithAddress(
      address,
      token,
      mapState
    )

    if (results.markets.length === 0) return { noResults: true, markets: [] }

    return { ...results, noResults: false }
  } else {
    const size = 50
    const response = await getMarketsByTerm(input, token, size)
    const markets = response.result.map(data => data.marketData)
    if (markets.length === 0) return { noResults: true }

    return { markets, noResults: false }
  }
}
